/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, OnInit } from '@angular/core';
import { HttpCallsCountService } from '../http-calls-counter.service';

//TODO rename to iriro-loading-bar
@Component({
  selector: 'iric-loading-bar, iriro-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
})
export class LoadingBarComponent implements OnInit {
  showLoadingBar: boolean | undefined = undefined;

  constructor(private readonly httpCallService: HttpCallsCountService) {}

  ngOnInit() {
    this.httpCallService
      .isShowLoadingBar()
      .subscribe((showLoadingBar: boolean) => {
        this.showLoadingBar = showLoadingBar;
      });
  }
}
